if (!customElements.get('product-form')) {
  var successTimeOut = null;
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (this.form?.querySelector('[name=id]'))
        this.form.querySelector('[name=id]').disabled = false;
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const wristSizing = this.form.querySelector('[data-wrist-sizing]');
      const requiredWristFields = wristSizing
        ? Array.from(wristSizing.querySelectorAll('[required]:not([disabled])'))
        : [];
      const invalidWristField = requiredWristFields.find((field) => !field.value.trim());

      if (invalidWristField) {
        this.handleErrorMessage(wristSizing.dataset.validationError);
        invalidWristField.focus();
        invalidWristField.reportValidity();
        return;
      }
      
      const submitButton = this.querySelector('[type="submit"]');
      const quickCart = this.querySelector("[id^=quick_add_cart]");
      if (submitButton.classList.contains('loading')) return;

      if (quickCart) quickCart.disabled = true;
      if (!quickCart?.classList.contains("loading")) {
        quickCart?.classList.add("loading");
      }
      if (!quickCart?.querySelector("span").classList.contains("hide_on_load")) {
        quickCart?.querySelector("span").classList.add("hide_on_load");
        quickCart?.querySelector("div").classList.remove("hide_on_load");
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.ml_add_to_cart')?.classList.add('hidden');
      this.querySelector('.scaling-dots')?.classList.remove('hidden');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      var success = false;
      if(successTimeOut) {
        clearTimeout(successTimeOut);
        successTimeOut = null;

        const successHolder = submitButton.querySelector(".success_holder");
        successHolder?.classList.add("hide");
      }
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          window.cartStatus = "added";
          this.cartNotification.renderContents(response, this.form.dataset.cartType);

          success = true;
          if (document.querySelector("cart-items.is-empty") && location?.pathname?.startsWith("/cart")) {
            location.reload();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.closePopus();
          if (quickCart) {
            quickCart.disabled = false;
            quickCart.classList.remove("loading");
            quickCart.classList.remove("scaling-dots");

            quickCart.querySelector("div").classList.add("hide_on_load");
            quickCart.querySelector("span").classList.remove("hide_on_load");
          }

          if(location?.pathname?.startsWith("/products")) {
            const successHolder = submitButton.querySelector(".success_holder");
            if(successHolder) {
              successHolder?.classList.remove("hide");
              setTimeout(() => {
                this.handleAddtocartLoading(submitButton);
              }, 250)
              successTimeOut = setTimeout(() => {
                successHolder?.classList.add("hide");
                successTimeOut = null;
                
              }, 3000)
            } else {
              this.handleAddtocartLoading(submitButton);
            }
          } else {
            this.handleAddtocartLoading(submitButton);
          }
        });
    }

    handleAddtocartLoading(submitButton) {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      this.querySelector('.scaling-dots')?.classList.remove('hidden');
      this.querySelector('.ml_add_to_cart')?.classList.remove('hidden');
      this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    }

    closePopus() {
      document.querySelectorAll("modal-dialog[open]").forEach(popup => {
        popup?.hide?.();
      })
    }

    handleErrorMessage(errorMessage = false) {
      if (this.dataset.quickAdd) {
        if (window.location.pathname.includes("/cart")) {
          setTimeout(() => {
            if (document.querySelector("cart-items.is-empty")) {
              location.reload();
            }
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            })
          }, 500)
        }
        return;
      }

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = typeof errorMessage === "object" ? Object.values(errorMessage).join(" & ") : errorMessage;
      }
    }
  });
}
